/* Header search is inserted dynamically by the theme. */
(() => {
  if (window.slHeaderSearchBound) return;
  window.slHeaderSearchBound = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  let search;
  function sync() {
    if (!search) return;
    const closed = search.classList.contains('hidden');
    document.body.classList.toggle('sl-header-search-open', !closed);
    search.querySelectorAll('[data-sl-search-styles]').forEach(link => { link.disabled = closed; });
    const modal = search.querySelector('.filter-modal');
    const panel = modal.querySelector('.cc-popup-modal');
    if (desktop.matches) {
      modal.setAttribute('aria-hidden', closed ? 'true' : 'false');
      panel.setAttribute('role', 'complementary');
      panel.removeAttribute('aria-modal');
    } else {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
    }
  }
  function init() {
    search = document.querySelector('.header-search-content');
    if (!search || search.dataset.slSearchReady) return;
    search.dataset.slSearchReady = 'true';
    new MutationObserver(sync).observe(search, { attributes:true, attributeFilter:['class'] });
    desktop.addEventListener('change', () => {
      if (!desktop.matches) search.querySelector('.filter-modal').setAttribute('aria-hidden', 'true');
      sync();
    });
    sync();
  }
  const content = document.querySelector('#content');
  if (content) new MutationObserver(init).observe(content, { childList:true });
  init();
})();
